import { useTranslation } from 'react-i18next';
import { Card, Spinner, Text } from '@oliasoft-open-source/react-ui-library';
import { isEmpty } from 'es-toolkit/compat';
import translations from 'client/internationalization/translation-map.json';
import { IObject } from 'common/interfaces/hierarchy-entities';
import { IQuery, IQueryResult } from 'common/interfaces/query';
import { DefaultResultTable } from './default-result-table';
import { QueryResultTable } from './query-result-table';

type TQueryResultProps = {
  result: IQueryResult | null;
  isRunning: boolean;
  query: IQuery;
  setFilters: (data: { [key: string]: string }) => void;
};

type DefaultQueryResult = Omit<IQueryResult, 'data'> & {
  data: {
    id: string;
    name: string;
    entityType: string;
    objects: { [k: string]: { id: string, name: string } }[];
  }[];
};

type TQueryResultTable = Omit<IQueryResult, 'data'> & {
  data: {
    id: string;
    name: string;
    entityType: string;
    objects: Record<string, IObject>[];
  }[];
};

export const QueryResult = ({
  query,
  result,
  setFilters,
  isRunning,
}: TQueryResultProps) => {
  const { t } = useTranslation();
  const { groupedDataType } = result || {};

  return (
    <Card bordered={false}>
      { isRunning && <Spinner dark small /> }
      { result && isEmpty(result) && <Text>{t(translations.query_noResults)}</Text> }
      { !isEmpty(result) && isEmpty(groupedDataType) && <DefaultResultTable queryResult={result as DefaultQueryResult} archiveId={query.archiveid} resultConfig={query.resultConfig} setFilters={setFilters} /> }
      { !isEmpty(result) && !isEmpty(groupedDataType) && <QueryResultTable queryResult={result as unknown as TQueryResultTable} archiveId={query.archiveid} resultConfig={query.resultConfig} setFilters={setFilters} /> }
    </Card>
  );
};
